import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { whitePvcDictEl } from "@/lib/shop/products/white-pvc";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/el/shop_/white-pvc")({
  head: () => ({
    ...buildProductHead(whitePvcDictEl),
    links: alternateLinkList("/shop/white-pvc", "el"),
  }),
  component: () => <ProductPage dict={whitePvcDictEl} />,
});
